import React, { useState } from "react";
import TimePicker from "react-times";
import { TextField, ClickAwayListener } from "@material-ui/core";
import "./timepicker.css";
import "react-times/css/classic/default.css";

export default props => {
    const [hour, setHour] = useState("");
    const [minute, setMinute] = useState("");
    const [focused, setFocused] = useState(false);
    return (
        <ClickAwayListener onClickAway={() => setFocused(false)}>
            <div className="time_picker_wrapper" style={{ width: "100%", paddingTop: "16px" }}>
                <span style={{ color: "rgba(0, 0, 0, 0.38)", fontSize: "12px" }}> {props.text} </span>
                <TimePicker
                    timeConfig={{
                        from: "05:00 AM",
                        to: "23:00 PM",
                        step: props?.step || 15,
                        unit: "minute"
                    }}
                    theme="classic"
                    trigger={
                        <TextField style={{ width: "100%" }} value={props.value} onClick={() => setFocused(!focused)} />
                    }
                    focused={focused}
                    timezone={props.timezone}
                    onFocusChange={setFocused}
                    onTimeChange={options => {
                        setHour(options.hour);
                        setMinute(options.minute);
                        props.changeValue(options.hour + ":" + options.minute + ":00");
                    }}
                    showTimezone={props.showTimezone}
                    time={hour && minute ? `${hour}:${minute}` : null}
                    closeOnOutsideClick={false}
                />
            </div>
        </ClickAwayListener>
    );
};
